import { useEffect, useState } from "react";
import SiteLogo from "../../../CommonComponents/SiteLogo";

const footerLinks = {
  "Usage and Terms": [
    { name: "Terms and Conditions", href: "#" },
    { name: "Privacy Policy", href: "#" },
  ],
  "Quick Links": [
    { name: "Deposits and Withdrawals Rules", href: "#" },
    { name: "Cookie Policy", href: "#" },
  ],
};

const partnerLogos = [
  { name: "Evolution", src: "/Icon/evolution.svg" },
  { name: "Ezugi", src: "/Icon/ezugi.svg" },
  { name: "Pragmatic Live", src: "/Icon/pragmatic.svg" },
  { name: "Betgames", src: "/Icon/betgames.svg" },
  { name: "Super Spade Games", src: "/Icon/superspade.svg" },
  { name: "Betsoft", src: "/Icon/betsoft.svg" },
  { name: "Spribe", src: "/Icon/spribe.svg" },
  { name: "Evoplay", src: "/Icon/evoplay.svg" },
  { name: "+18", src: "/Icon/logo-18plus.svg" },
  { name: "Secure", src: "/Icon/secure-icon.png" },
  { name: "SSL", src: "/Icon/ssl-icon.png" },
];

export default function Footer() {
  const [hostname, setHostname] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setHostname(window.location.hostname);
    }
  }, []);

  return (
    <footer className="text-gray-800 font-sans pt-4 -mb-[80px]">
      <div className="overflow-hidden relative">
        <div className="flex animate-scroll mb-6">
          {[...partnerLogos, ...partnerLogos].map((logo, index) => (
            <div
              key={`${logo.name}-${index}`}
              className="flex justify-center items-center p-1.5 bg-white rounded-md shadow-sm hover:shadow-md transform hover:scale-105 transition-all duration-300 border border-[#efefef] mx-1.5 flex-shrink-0"
            >
              <img
                src={logo.src}
                alt={logo.name}
                className="h-8 w-8 sm:h-10 sm:w-10 object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto pb-8">

        {/* Footer Links */}
        <div className="grid px-4 sm:px-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6 sm:mb-8">
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-base sm:text-lg font-semibold text-[#16464c] mb-3 tracking-tight">
                {title === "Asianexchange" ? hostname : title}
              </h3>
              <ul className="space-y-1.5">
                {links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-gray-600 hover:text-[#16464c] text-xs sm:text-sm transition-colors duration-200 inline-block py-0.5"
                      aria-label={link.name}
                    >
                      {link.name.replace("asianexchange", hostname)}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-200 pt-4 pb-3 px-4 text-justify">
          <p className="text-[10px] sm:text-xs text-gray-500 leading-relaxed ">
            You must be over 18 years old, or the legal age at which gambling or
            gaming activities are allowed under the law or jurisdiction that
            applies to you. Access is restricted in regions where online gaming is
            not permitted.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="mt-4 flex flex-col items-center text-xs sm:text-sm text-gray-600 space-y-3 sm:flex-row sm:justify-between sm:space-y-0">
          <div className="flex flex-col items-center sm:flex-row sm:space-x-2">
            {/* <img
              src={AsianExchangeLogo}
              alt={window.location.hostname}
              className=""
              loading="lazy"
            /> */}
            <SiteLogo className="h-6 w-auto mb-1.5 sm:mb-0" />
            <span>© {new Date().getFullYear()} {hostname}. All rights reserved.</span>
          </div>
          <div className="flex flex-wrap justify-center space-x-3 sm:space-x-4">
            <a
              href="#"
              className="text-gray-600 hover:text-[#16464c] transition-colors duration-200 py-0.5"
              aria-label="Contact Us"
            >
              Contact Us
            </a>
            <a
              href="#"
              className="text-gray-600 hover:text-[#16464c] transition-colors duration-200 py-0.5"
              aria-label="Support"
            >
              Support
            </a>
            <a
              href="#"
              className="text-gray-600 hover:text-[#16464c] transition-colors duration-200 py-0.5"
              aria-label="Twitter"
            >
              <svg className="h-4 w-4 sm:h-5 sm:w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.48 4.48 0 00-.08-.83A7.72 7.72 0 0023 3z" />
              </svg>
            </a>
            <a
              href="#"
              className="text-gray-600 hover:text-[#16464c] transition-colors duration-200 py-0.5"
              aria-label="Facebook"
            >
              <svg className="h-4 w-4 sm:h-5 sm:w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22 12a10 10 0 10-11 10V14h-3v-3h3V8.5A3.5 3.5 0 0114.5 5H17v3h-2a.5.5 0 00-.5.5V11h2.5l-.5 3H14v8a10 10 0 008-10z" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <style jsx>{`
        .animate-scroll {
          display: flex;
          animation: scroll 20s linear infinite;
          width: max-content;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        @media (max-width: 640px) {
          .animate-scroll {
            animation-duration: 15s;
          }
        }
      `}</style>
    </footer>
  );
}